function InventoryTileAnalysis() {
    this.OrganizationName = "";
    this.OrganizationId = 0;
    this.TotalDevices = 0;
    this.Assigned = 0;
    this.UnAssigned = 0;
    this.Shipped = 0;
    this.Received = 0;
    this.Returned = 0;
    this.Recalled = 0;
    this.ShelfRate = 0;
    this.ShelfRateAllowed = 0;
    this.ShelfRateExceeded = 'none';
    this.ShelfRateExceededFlag = false;
}
if (typeof exports !== 'undefined') {
    module.exports = InventoryTileAnalysis;
}